/**
 * Suppliers Repository (ADR-0009).
 */

import { queueBusinessPayloadFieldWrite } from '../storage/businessPayloadWrite';
import { publishDomainEvent, DOMAIN_EVENTS } from '../events/domainEventBus';
import {
  readSuppliersFromBestSource,
  refreshSuppliersReadCache
} from '../../utils/suppliersReadSource';

export class KvSuppliersRepository {
  /**
   * @param {string} businessId
   */
  async listSuppliers(businessId) {
    return readSuppliersFromBestSource(businessId);
  }

  /**
   * @param {string} businessId
   * @param {Array} suppliers
   */
  async replaceSuppliers(businessId, suppliers, options = {}) {
    const next = Array.isArray(suppliers) ? suppliers : [];
    let prev = [];
    if (!options.fromCloudPull && !options.skipDeleteDiff) {
      try {
        prev = await readSuppliersFromBestSource(businessId);
      } catch {
        prev = [];
      }
    }
    await queueBusinessPayloadFieldWrite(businessId, 'suppliers', next);
    await refreshSuppliersReadCache(businessId);
    publishDomainEvent(DOMAIN_EVENTS.SUPPLIERS_UPDATED, { businessId, suppliers: next });
    if (!options.fromCloudPull) {
      try {
        const { enqueueHybridEntitySync } = await import('../../services/hybridCatalogSync');
        const { enqueueHybridDeletesForRemoved } = await import('../../services/hybridDeleteSync');
        if (!options.skipDeleteDiff) {
          void enqueueHybridDeletesForRemoved(businessId, 'supplier', prev, next);
        }
        const { listChangedHybridEntities } = await import('../../services/hybridDiff');
        const changed = listChangedHybridEntities('supplier', prev, next);
        for (const item of changed) {
          void enqueueHybridEntitySync(businessId, 'supplier', item);
        }
      } catch {
        /* optional */
      }
    }
    return next;
  }
}
